import React from 'react';
import { heritageColors } from '../../../../heritageTheme.ts';

const TYPE_LABELS = {
  medic: { label: 'חובש', color: '#2d5a3d' },
  paramedic: { label: 'פרמדיק', color: '#1e3a5f' },
  maar: { label: 'מע"ר', color: '#b8860b' },
};

/**
 * Compact – תבנית קומפקטית אנכית לחירום
 * שורה אחת צפופה לכל כונן עם תג סוג צבעוני – מתאימה למידות קטנות
 */
const Compact = ({
  initialData = { volunteers: { medic: [], paramedic: [], maar: [] } },
  title = 'חירום והצלה',
  showTitle = true,
}) => {
  const volunteers = initialData.volunteers || { medic: [], paramedic: [], maar: [] };

  const allVolunteers = [
    ...(volunteers.medic || []).map(v => ({ ...v, type: 'medic' })),
    ...(volunteers.paramedic || []).map(v => ({ ...v, type: 'paramedic' })),
    ...(volunteers.maar || []).map(v => ({ ...v, type: 'maar' })),
  ];

  return (
    <div style={{
      padding: '0.75em',
      direction: 'rtl',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      fontSize: 'inherit',
    }}>
      {showTitle && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.4em',
          paddingBottom: '0.5em',
          marginBottom: '0.5em',
          borderBottom: `0.03125em solid ${heritageColors.emergency}40`,
        }}>
          <span className="material-symbols-outlined" style={{
            color: heritageColors.emergency,
            fontSize: '1.1em',
          }}>ambulance</span>
          <h3 style={{
            margin: 0,
            fontWeight: 'bold',
            color: heritageColors.emergency,
            fontSize: '0.8125em',
          }}>{title}</h3>
        </div>
      )}

      {allVolunteers.length === 0 ? (
        <div style={{ color: heritageColors.emergency, fontSize: '0.8125em', textAlign: 'center' }}>
          אין כוננים זמינים
        </div>
      ) : (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.1875em',
          flex: 1,
          overflow: 'auto',
        }}>
          {allVolunteers.map((v, index) => {
            const typeInfo = TYPE_LABELS[v.type] || { label: 'כונן', color: heritageColors.emergency };
            return (
              <div
                key={v.id || index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5em',
                  padding: '0.3125em 0.5em',
                  borderRadius: '0.25em',
                  backgroundColor: index % 2 === 0 ? 'transparent' : '#fdf2f2',
                  borderRight: `0.1875em solid ${typeInfo.color}`,
                }}
              >
                {/* תג סוג */}
                <span style={{
                  fontSize: '0.5625em',
                  color: typeInfo.color,
                  fontWeight: 700,
                  backgroundColor: `${typeInfo.color}15`,
                  padding: '0.125em 0.375em',
                  borderRadius: '0.1875em',
                  minWidth: '3em',
                  textAlign: 'center',
                }}>
                  {typeInfo.label}
                </span>

                <span style={{
                  color: heritageColors.navy,
                  fontWeight: 'bold',
                  fontSize: '0.8125em',
                  flex: 1,
                }}>
                  {v.name}
                </span>

                <span style={{
                  color: heritageColors.emergency,
                  fontSize: '0.75em',
                  fontWeight: 'bold',
                  direction: 'ltr',
                }}>
                  {v.phone}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Compact;
